import React, { useEffect, useRef, Fragment } from 'react';

import umuWebview from '@umu/umu-webview';
import { isSameObj } from '@umu/umu-util';
import { usePrev } from '@umu/umu-react-hooks';

import { LANG } from '../@utils/webview';
import { EAppShareType as ShareType, UnknownObj } from '@umu/umu-types';

interface IShareOption {
    obj_type: ShareType;
    shareUrl: string;
    shareIcon: string;
    shareTitle: string;
    shareDesc: string;
}

interface IProps {
    option: IShareOption;
    onFail?(): void;
    onSuccess?(): void;
}

export const CallAppBottomShare = (props: IProps) => {
    const { option, onFail, onSuccess } = props;
    const prevOption = usePrev(option);
    const isInApp = umuWebview.UA_INFO.isUMUWebview;
    const statusRef = useRef<null | boolean>(null);

    const callBack = (res: { status: 0 | 1 }) => {
        statusRef.current = res.status === 1;
        if (statusRef.current) {
            if (onSuccess) {onSuccess();}
        } else {
            if (onFail) {onFail();}
        }
    };

    useEffect(() => {
        if (!isInApp || isSameObj(prevOption as unknown as UnknownObj, option as unknown as UnknownObj)) {
            return;
        }
        umuWebview.callHandler('callBottomShare', option, callBack as any, LANG);
        statusRef.current = null;
        if (onFail) {
            setTimeout(() => {
                if (statusRef.current === null) {
                    onFail();
                }
            }, 1000);
        }
    }, [option]);

    return <Fragment />;
};
